import { Tooltip, withStyles } from '@material-ui/core';
import { createStyles, Theme, WithStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import React from 'react';
const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11
    },
    blur: {
      filter: 'blur(2px)'
    }
  });
class MyTooltip extends React.Component<IMyTooltip> {
  public render() {
    const { classes, title, blur, ...rest } = this.props;
    return (
      <Tooltip
        interactive
        classes={{
          tooltip: classnames(classes.root, {
            [classes.blur]: blur ? true : false
          })
        }}
        title={title}
        placement={'bottom-start'}
        {...rest}
      >
        <div>{this.props.children}</div>
      </Tooltip>
    );
  }
}
interface IMyTooltipOwnProps extends WithStyles<typeof styles> {
  title: string;
  blur?: boolean;
}
type IMyTooltip = IMyTooltipOwnProps;
export default withStyles(styles)(MyTooltip);
